import { getCategoryDataAPI, getProspectiveCategoryDataAPI } from "../api/CategoryApi";


const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

const initialState = {
    categoryData: {},
    prospectiveCategory: {},
    loading: false,
    successful: false,
    status: ''
}

export const getSeoCategoryData = createAsyncThunk(
    "blog/getSeoCategoryData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getCategoryDataAPI(payload);
            return response?.data;
        } catch (err) {
            return rejectWithValue({    
                errorMessage: err?.message,
            });
        }
    }
);

export const getProspectiveSeoCategoryData = createAsyncThunk(
    "blog/getProspectiveSeoCategoryData",
    async (payload, { rejectWithValue }) => {
        try {
            const response = await getProspectiveCategoryDataAPI(payload);
            return response?.data;
        } catch (err) {
            return rejectWithValue({    
                errorMessage: err?.message,
            });
        }
    }
);

const categoryDataSlice = createSlice({
    name: "categoryData",
    initialState,
    extraReducers: (builder) => {
        // get Seo Category
        builder.addCase(getSeoCategoryData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getSeoCategoryData.fulfilled, (state, action) => {
            state.categoryData = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getSeoCategoryData.rejected, (state) => {
            state.loading = true;
        });

        // get Prospective Seo Category
        builder.addCase(getProspectiveSeoCategoryData.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getProspectiveSeoCategoryData.fulfilled, (state, action) => {
            state.prospectiveCategory = action?.payload;
            state.successful = false;
            state.loading = false;
        });
        builder.addCase(getProspectiveSeoCategoryData.rejected, (state) => {
            state.loading = true;
        });
    },
});

export default categoryDataSlice.reducer;